var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-data"},[_c('div',{staticClass:"card-title"},[_c('h4',[_vm._v(_vm._s(_vm.title))]),(_vm.sub)?_c('small',[_vm._v(_vm._s(_vm.sub))]):_vm._e()]),_c('div',{staticClass:"right",attrs:{"id":"percentage"}},[_c('ICountUp',{attrs:{"endVal":_vm.total,"options":_vm.options}}),_vm._v("\n        %\n    ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }